/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find(list, f) {
  return list.filter(f)[0]
}

export function addZero(ind) {
  if (ind >= 0 && ind < 10) {
    return '00' + ind
  } else if (ind >= 10 && ind < 100) {
    return '0' + ind
  }
}

export function sortBy(attr, rev) {
  // 第二个参数没有传递 默认升序排列
  if (rev === undefined) {
    rev = 1
  } else {
    rev = (rev) ? 1 : -1
  }

  return function(a, b) {
    a = a[attr]
    b = b[attr]
    if (a < b) {
      return rev * -1
    }
    if (a > b) {
      return rev * 1
    }
    return 0
  }
}

/**
   * Deep copy the given object considering circular structure.
   * This function caches all nested objects and its copies.
   * If it detects circular structure, use cached copy to avoid infinite loop.
   *
   * @param {*} obj
   * @param {Array<Object>} cache
   * @return {*}
   */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
   * forEach for object
   */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
  return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function partial(fn, arg) {
  return function() {
    return fn(arg)
  }
}

export function downloadUrlFile(url, fileName) {
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style = 'display: none'
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}

// 数据拷贝
export function copyData(target) {
  // 先判断类型，再拷贝

  function checkType(val) {
    return Object.prototype.toString.call(val).slice(8, -1)
  }

  let res; const type = checkType(target)
  if (type === 'Object') {
    res = {}
  } else if (type === 'Array') {
    res = []
  } else {
    return target
  }

  for (const i in target) { // 数组和对象 for in 循环
    const value = target[i]
    if (checkType(value) === 'Object' || checkType(value) === 'Array') { // 嵌套
      res[i] = copyData(value)
    } else { // 基本数据或者函数
      res[i] = value
    }
  }
  return res
}

export function _trackPageview(contentUrl, refererUrl) {
  if (window._czc) {
    window._czc.push(['_trackPageview', contentUrl, refererUrl])
  }
}

export function _trackEvent(category, action, label, value, nodeid) {
  if (window._czc) {
    window._czc.push(['_trackEvent', category, action, label, value, nodeid])
  }
}

import CryptoJS from 'crypto-js'
/**
 * CryptoJS 加密
 *
 * @param {String} encryptData  需要加密数据
 * @returns 加密后的数据
 * @memberof Utils
 */
export const encrypt = (encryptData) => {
  var key = CryptoJS.enc.Utf8.parse('as-Crypto-js')
  var srcs = CryptoJS.enc.Utf8.parse(encryptData)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}
/**
 * CryptoJS 解密
 *
 * @param {String} encryptData  需要加密数据
 * @returns 解密后的数据
 * @memberof Utils
 */
export const decrypt = (encryptData) => {
  if(encryptData){
    var key = CryptoJS.enc.Utf8.parse('as-Crypto-js')
    var decrypted = CryptoJS.AES.decrypt(encryptData, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypted).toString()
  }

}